import { render, staticRenderFns } from "./ImageText.vue?vue&type=template&id=2c9ba55e&scoped=true"
import script from "./ImageText.vue?vue&type=script&lang=js"
export * from "./ImageText.vue?vue&type=script&lang=js"
import style0 from "./ImageText.vue?vue&type=style&index=0&id=2c9ba55e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ba55e",
  null
  
)

export default component.exports